import CreditSummary from './CreditSummary';

export default CreditSummary;
